import { z } from 'zod';

import { validatePhoneNumber } from './utils';

export const UnifiedUserFormSchema = z
  .object({
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    selectedPhoneNumber: z.string().min(1, 'Please select a phone number'),
    newPhoneNumber: z.string().default(''),
    countryCode: z.string().optional().default('US'),
  })
  .refine(
    (data) =>
      data.selectedPhoneNumber !== 'new' ||
      (data.selectedPhoneNumber === 'new' &&
        !!data.newPhoneNumber &&
        validatePhoneNumber(data.newPhoneNumber, data.countryCode)),
    {
      message: 'Please enter a valid phone number',
      path: ['newPhoneNumber'],
    }
  );

export type TUnifiedUserFormData = z.infer<typeof UnifiedUserFormSchema>;
